<template>
  <div
    id="testimonial-2"
    class="testimonial-section section-padding tw-pt-10"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <div class="container">
      <!-- Başlık ve açıklama -->
      <div class="row">
        <div class="col-xl-6 col-lg-5">
          <div class="section-title text-low">
            <h2 :style="`color: var(--c-${vars.titleColor})`" v-html="vars.titleText"></h2>
          </div>
        </div>
        <div class="col-xl-6 col-lg-7 text-lg-end">
          <p :style="`color: var(--c-${vars.textColor})`">
            {{ vars.descriptionText }}
          </p>
        </div>
      </div>

      <!-- Carousel: sadece tarayıcıda gösterilecek -->
      <div class="row mt-40">
        <div v-if="isBrowser" ref="carousel" class="testimonial-carousel owl-carousel">
          <div class="item" v-for="review in reviews" :key="review._id">
            <div class="single-testimonial-item">
              <div class="testimonial-img mb-30 d-flex flex-column align-items-start">
                <div class="d-flex align-items-center mb-2">
                  <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="54" height="54" rx="27" fill="#EEEEEE" />
                    <g clip-path="url(#clip0_335_408)">
                      <path
                        d="M23.3606 15.7894C20.9626 16.6213 18.8946 18.2002 17.4603 20.2943C16.026 22.3884 15.301 24.8872 15.3919 27.4237C15.4827 29.9603 16.3846 32.4008 17.965 34.3869C19.5454 36.373 21.7211 37.8 24.1724 38.4582C26.1598 38.971 28.2419 38.9935 30.2399 38.5238C32.0499 38.1173 33.7233 37.2476 35.0962 36.0001C36.5251 34.662 37.5622 32.9597 38.0962 31.0763C38.6765 29.0282 38.7798 26.8743 38.3981 24.7801H27.2381V29.4094H33.7012C33.572 30.1478 33.2952 30.8525 32.8873 31.4814C32.4795 32.1102 31.9489 32.6504 31.3274 33.0694C30.5382 33.5915 29.6485 33.9428 28.7156 34.1007C27.7798 34.2747 26.82 34.2747 25.8843 34.1007C24.9359 33.9046 24.0387 33.5132 23.2499 32.9513C21.9827 32.0543 21.0312 30.7799 20.5312 29.3101C20.0227 27.8127 20.0227 26.1893 20.5312 24.6919C20.8871 23.6423 21.4755 22.6867 22.2524 21.8963C23.1415 20.9752 24.2672 20.3168 25.5058 19.9933C26.7445 19.6698 28.0484 19.6938 29.2743 20.0626C30.232 20.3565 31.1078 20.8702 31.8318 21.5626C32.5606 20.8376 33.2881 20.1107 34.0143 19.3819C34.3893 18.9901 34.7981 18.6169 35.1674 18.2157C34.0622 17.1872 32.765 16.3869 31.3499 15.8607C28.7731 14.925 25.9536 14.8999 23.3606 15.7894Z"
                        fill="white"
                      />
                      <path
                        d="M23.3607 15.7894C25.9536 14.8992 28.7731 14.9237 31.3501 15.8587C32.7654 16.3885 34.062 17.1927 35.1657 18.225C34.7907 18.6262 34.3951 19.0012 34.0126 19.3912C33.2851 20.1175 32.5582 20.8412 31.832 21.5625C31.1079 20.8701 30.2321 20.3565 29.2745 20.0625C28.0489 19.6924 26.7451 19.6671 25.5061 19.9893C24.2671 20.3114 23.1408 20.9686 22.2507 21.8887C21.4738 22.6791 20.8854 23.6348 20.5295 24.6844L16.6426 21.675C18.0338 18.916 20.4427 16.8057 23.3607 15.7894Z"
                        fill="#E4B600"
                      />
                      <path
                        d="M15.6114 24.6561C15.8203 23.6207 16.1672 22.618 16.6427 21.6748L20.5295 24.6917C20.0211 26.1891 20.0211 27.8124 20.5295 29.3098C19.2345 30.3098 17.9389 31.3148 16.6427 32.3248C15.4523 29.9554 15.0893 27.2557 15.6114 24.6561Z"
                        fill="#F8BD00"
                      />
                      <path
                        d="M27.2381 24.7783H38.3981C38.7799 26.8726 38.6766 29.0264 38.0963 31.0746C37.5623 32.958 36.5252 34.6602 35.0963 35.9983C33.8419 35.0196 32.5819 34.0483 31.3275 33.0696C31.9494 32.6501 32.4802 32.1094 32.8881 31.4798C33.296 30.8503 33.5726 30.1448 33.7013 29.4058H27.2381C27.2363 27.8646 27.2381 26.3214 27.2381 24.7783Z"
                        fill="#587DBD"
                      />
                      <path
                        d="M16.6406 32.3251C17.9369 31.3251 19.2325 30.3201 20.5275 29.3101C21.0285 30.7804 21.9814 32.0549 23.25 32.9513C24.0413 33.5106 24.9404 33.8988 25.89 34.0913C26.8257 34.2653 27.7855 34.2653 28.7213 34.0913C29.6542 33.9334 30.5439 33.5821 31.3331 33.0601C32.5875 34.0388 33.8475 35.0101 35.1019 35.9888C33.7292 37.237 32.0558 38.1073 30.2456 38.5144C28.2476 38.9841 26.1655 38.9616 24.1781 38.4488C22.6063 38.0291 21.1381 37.2893 19.8656 36.2757C18.5187 35.2063 17.4187 33.8588 16.6406 32.3251Z"
                        fill="#319F43"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_335_408">
                        <rect width="24" height="24" fill="white" transform="translate(15 15)" />
                      </clipPath>
                    </defs>
                  </svg>
                  <h5 class="mb-0 ms-3">Google Reviews</h5>
                </div>

                <div class="d-flex mt-2">
                  <svg
                    v-for="n in review.evaluation_value"
                    :key="`testimonials-star-${n}`"
                    width="24"
                    height="24"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="me-1"
                  >
                    <path
                      d="M10 1.25L12.472 7.5H19L13.764 10.972L15.236 17.5L10 13.444L4.764 17.5L6.236 10.972L1 7.5H7.528L10 1.25Z"
                      fill="#E4B600"
                    />
                  </svg>
                </div>
              </div>

              <p class="tw-text-start !tw-text-black" v-html="review.content"></p>

              <div class="testimonial-author">
                <h5 class="tw-text-start">{{ review.person_name }}</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineComponent({
  name: 'Theme9GoogleReview',
  mixins: [ComponentMixin],
  data() {
    return {
      reviews: [] as any[],
      isBrowser: false,
    };
  },
  created() {
    const parsed = (this as any).parseFormV2(this.vars.googleReviews);
    this.reviews = parsed?.reviews?.filter((r: any) => r.content?.trim()) || [];
  },
  mounted() {
    // Sadece client-side
    this.isBrowser = true;
    this.$nextTick(() => {
      this._initOwl();
    });
  },
  beforeUnmount() {
    this._destroyOwl();
  },
  methods: {
    _initOwl(attempts = 8) {
      const $ = (window as any).jQuery;
      if (!($ && $.fn && $.fn.owlCarousel)) {
        if (attempts > 0) {
          setTimeout(() => this._initOwl(attempts - 1), 50);
        }
        return;
      }
      const $owl = $(this.$el).find('.testimonial-carousel');
      if (!$owl.length) {
        if (attempts > 0) {
          setTimeout(() => this._initOwl(attempts - 1), 50);
        }
        return;
      }
      if ($owl.hasClass('owl-loaded')) {
        $owl.trigger('destroy.owl.carousel');
        $owl.find('.owl-stage-outer').children().unwrap();
        $owl.removeClass('owl-loaded');
      }
      $owl.owlCarousel({
        loop: true,
        margin: 30,
        nav: true,
        dots: true,
        smartSpeed: 0,
        fluidSpeed: 0,
        dragEndSpeed: 0,
        navText: ['<i class="icon-left-arrow"></i>', '<i class="icon-right-arrow"></i>'],
        responsive: {
          0: { items: 1 },
          768: { items: 2 },
          1200: { items: 3 },
        },
      });
    },
    _destroyOwl() {
      const $ = (window as any).jQuery;
      const $owl = $(this.$el).find('.testimonial-carousel');
      if ($owl && $owl.hasClass('owl-loaded')) {
        $owl.trigger('destroy.owl.carousel');
      }
    },
  },
});
</script>

<style scoped>
.single-testimonial-item {
  width: 100%;
  max-width: 450px;
  max-height: 750px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #fff;
  padding: 2rem;
  border: 1px solid var(--c-border);
  text-align: left;
}
.single-testimonial-item p {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  overflow: hidden;
  margin-bottom: 1rem;
}
.separator {
  width: 40px;
  height: 2px;
  background-color: var(--c-primary);
  margin: 1rem auto;
}
.testimonial-carousel .item {
  display: flex;
  justify-content: center;
}
.owl-stage,
.owl-item {
  transition: none !important;
}
.owl-nav {
  display: flex !important;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
}
</style>
